export const LIST_CONFIGURATIONS_REQUEST = 'LIST_CONFIGURATIONS_REQUEST';
export const LIST_CONFIGURATIONS_SUCCESS = 'LIST_CONFIGURATIONS_SUCCESS';
export const LIST_CONFIGURATIONS_FAILURE = 'LIST_CONFIGURATIONS_FAILURE';

export const GET_CONFIGURATION_REQUEST = 'GET_CONFIGURATION_REQUEST';
export const GET_CONFIGURATION_SUCCESS = 'GET_CONFIGURATION_SUCCESS';
export const GET_CONFIGURATION_FAILURE = 'GET_CONFIGURATION_FAILURE';

export const CREATE_CONFIGURATION_REQUEST = 'CREATE_CONFIGURATION_REQUEST';
export const CREATE_CONFIGURATION_SUCCESS = 'CREATE_CONFIGURATION_SUCCESS';
export const CREATE_CONFIGURATION_FAILURE = 'CREATE_CONFIGURATION_FAILURE';

export const UPDATE_CONFIGURATION_REQUEST = 'UPDATE_CONFIGURATION_REQUEST';
export const UPDATE_CONFIGURATION_SUCCESS = 'UPDATE_CONFIGURATION_SUCCESS';
export const UPDATE_CONFIGURATION_FAILURE = 'UPDATE_CONFIGURATION_FAILURE';

export const DELETE_CONFIGURATION_REQUEST = 'DELETE_CONFIGURATION_REQUEST';
export const DELETE_CONFIGURATION_SUCCESS = 'DELETE_CONFIGURATION_SUCCESS';
export const DELETE_CONFIGURATION_FAILURE = 'DELETE_CONFIGURATION_FAILURE';

export const CONFIGURATION = 'CONFIGURATION';
export const CONFIGURATIONS = 'CONFIGURATIONS';

export const UPDATE_CONFIGURATION = 'UPDATE_CONFIGURATION';
export const RESET_CONFIGURATION = 'RESET_CONFIGURATION';

export const UPDATE_CONFIGURATIONS = 'UPDATE_CONFIGURATIONS';
export const RESET_CONFIGURATIONS = 'RESET_CONFIGURATIONS';



// WEBPACK FOOTER //
// ./src/store/modules/configuration/types.js